module.exports = __webpack_public_path__ + "folder.png?e5b3294cb7fc9f2e974011f0131c03bf";